import React from "react";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../../components/noData/noData";
import FilterBar from "./FilterBar";
import { DataPoints } from "./DataPoints";
import DiscountsPieChart from "./DiscountsPieChart";
import DiscountsTable from "./DiscountsTable";

const BreakdownView = () => {
  const updatesLoading = useSelector((state) => state.discounts.updatesLoading);
  // pieCharts and table.data both come from the same package_breakdown on the backend, so they're
  // always empty/non-empty together — checking one is enough to decide the whole view has no data.
  const hasData = useSelector((state) => !!state.discounts.chartsData.table?.data?.length);

  return (
    <div>
      <FilterBar />

      <div data-testid="charts-container" className="chart-root">
        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : hasData ? (
          <>
            <div className="summary">
              <DataPoints />
              <DiscountsPieChart />
            </div>

            <DiscountsTable />
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default BreakdownView;
